import { Quote } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "Opened the haldi pouch in my kitchen and my mother-in-law asked if I'd cooked something already. That's the aroma test — Maati passed.",
    name: "Aarti Rao",
    city: "Bengaluru",
  },
  {
    quote:
      "The red chilli is the real deep-red, not that orange industrial stuff. You taste the sun in it. Reminded me of my grandmother's shelf.",
    name: "Faizan Khan",
    city: "Hyderabad",
  },
  {
    quote:
      "Switched our cloud kitchen to Maati's masala powder last quarter. Customers noticed before our chefs did. Rare to find a brand this honest.",
    name: "Priya Menon",
    city: "Kochi · Runs 2 kitchens",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-mo-terracotta mb-4">
            — Loved & Told-about
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-mo-ink leading-[1.05]">
            What our kitchen <span className="italic text-mo-green">family</span> says.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-7">
          {REVIEWS.map((r, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative p-8 rounded-2xl bg-[#F9F6F0] border border-[#5C5248]/12 hover:border-[#D99026]/50 transition-colors duration-500"
            >
              <Quote className="text-mo-turmeric" size={28} />
              <blockquote className="mt-5 font-serif-display text-xl leading-snug text-mo-ink">
                "{r.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[#5C5248]/15">
                <div className="font-medium text-mo-ink text-sm">{r.name}</div>
                <div className="text-xs text-mo-ink-soft mt-0.5">{r.city}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
